import React from 'react';
import { usePathname } from 'next/navigation';
import * as S from './LogoLink.styles';
import { ROUTES } from '@/constants/routes';
import {
  ASPECT_RATIO_COEFFICIENT,
  DATA_TEST_ID,
} from '@/components/LogoLink/LogoLink.constants';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { PageType } from '@/hooks/usePageType/usePageType.types';
import { usePageType } from '@/hooks/usePageType/usePageType';

interface LogoLinkProps {
  width?: number;
  onClick?: (event: React.MouseEvent) => void;
  hasCenterAbsolute?: boolean;
}

export const LogoLink: React.FC<LogoLinkProps> = ({
  width = 73,
  onClick,
  hasCenterAbsolute = true,
}) => {
  const pathname = usePathname();
  const pageType = usePageType();
  const isLeftAlignedOnDesktop =
    [PageType.NewAd, PageType.EditAd].includes(pageType) ||
    pathname === ROUTES.businessLanding;

  return (
    <S.LogoLinkBox
      href={ROUTES.home}
      onClick={onClick}
      dataTestId={DATA_TEST_ID}
      $hasCenterAbsolute={hasCenterAbsolute}
      aria-label="Tap.az"
      $isLeftAlignedOnDesktop={isLeftAlignedOnDesktop}
    >
      <IconBox
        data-testid="logo-link-icon"
        $filename="Tap.svg"
        $width={width}
        $height={Math.round(width / ASPECT_RATIO_COEFFICIENT)}
      />
    </S.LogoLinkBox>
  );
};
